import { Services, getServiceNameViaPoint } from '@sigma-frontend-libs/commons'
import { isUUID } from '@sigmasms/commons'

import { isEmpty, permissionPresets, proxy } from '@/utils'

import render from './render'

export default {
  name: 'Form',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    isNew: Boolean,
    loading: Boolean
  },

  data() {
    return {
      hasActiveDomains: false,
      generationParamsValidation: false,
      expireUrlValid: true
    }
  },

  computed: {
    canGetDomainsAsAdmin() {
      return this.checkPermissions(`advanced.${getServiceNameViaPoint(Services['url-shortener-settings/domains'])}.get`)
    },
    canGetDomains() {
      return this.checkPermissions(`advanced.${getServiceNameViaPoint(Services['url-shortener-settings/domains'])}.get`, permissionPresets.meUp)
    },

    domainIdValidation() {
      return !isEmpty(this.proxy.domainId) && isUUID(this.proxy.domainId)
    },

    validation() {
      return Boolean(this.domainIdValidation && this.generationParamsValidation && this.expireUrlValid)
    },

    prependItems() {
      const domain = this.proxy.domain
      if (domain) {
        return [ { domain } ]
      }
    }
  },

  watch: {
    validation() {
      this.$emit('validation', this.validation)
    },

    'proxy.ownerId'() {
      this.proxy.domainId = undefined
    }
  },

  mounted() {
    this.$emit('validation', this.validation)
  },

  methods: {
    _inputFilter(result) {
      const length = Number(result.generationParams.length)
      if (!isNaN(length)) {
        result.generationParams.length = length
      }

      return result
    }
  },

  render
}
